import { createContext, useContext } from 'react';

// we allow 'any' for customFunctions and customProps for flexibility and reusability for the table
interface IListViewTableContext {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  customFunctions: Record<string, (...args: Array<any>) => void>;
  customProps: Record<string, any>;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  isActionPending: boolean;
  isCurrencyConversionDisabled: boolean;
  isReadAuthorized: boolean;
  isUpdating: boolean;
  isWriteAuthorized: boolean;
  setDeleteModalID: React.Dispatch<React.SetStateAction<string>>;
  setDeleteModalName: React.Dispatch<React.SetStateAction<string>>;
  setIsDeleteModalActive: React.Dispatch<React.SetStateAction<boolean>>;
  setActiveModalID: React.Dispatch<React.SetStateAction<string>>;
  setActiveModalName: React.Dispatch<React.SetStateAction<string>>;
  setIsActiveModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ListViewTableContext = createContext({} as IListViewTableContext);
export const useListViewTableStore = (): IListViewTableContext => useContext(ListViewTableContext);
